import React from "react";
import LegalLayout from "../components/LegalLayout";

const COMPANY = {
  name: "Bottega di Nalise",
  vat: "03399260128",
  address: "Via Sabotino 32, 21049 Tradate (VA) — Italy",
  email: "info@nalise.it",
};

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-display font-bold text-2xl text-slate-900">{title}</h2>
    {children}
  </section>
);

const PrivacyPage = () => (
  <LegalLayout title="Informativa sulla Privacy" lastUpdate="Febbraio 2026">
    <p>
      La presente informativa è resa ai sensi dell'art. 13 del Regolamento UE 2016/679
      (GDPR) a tutti coloro che interagiscono con il sito {COMPANY.name}.
    </p>

    <Section title="1. Titolare del trattamento">
      <p>
        Il Titolare del trattamento dei dati è <strong>{COMPANY.name}</strong> (P.IVA{" "}
        {COMPANY.vat}), con sede in {COMPANY.address}. Email:{" "}
        <a href={`mailto:${COMPANY.email}`} className="text-sky-600 underline">{COMPANY.email}</a>.
      </p>
    </Section>

    <Section title="2. Tipologia di dati raccolti">
      <ul className="list-disc pl-6 space-y-1">
        <li>Dati di navigazione (indirizzi IP, log di accesso, browser, sistema operativo)</li>
        <li>Dati forniti volontariamente dall'utente (nome, cognome, email, telefono, indirizzo di spedizione e fatturazione)</li>
        <li>Dati di pagamento gestiti direttamente dai provider PayPal e WooCommerce (non vengono memorizzati su questo sito)</li>
        <li>Eventuali messaggi inviati alla chat di OBI o tramite i form di contatto</li>
      </ul>
    </Section>

    <Section title="3. Finalità del trattamento">
      <ul className="list-disc pl-6 space-y-1">
        <li>Esecuzione del contratto di vendita (ordini, spedizione, fatturazione)</li>
        <li>Adempimenti di legge fiscali e contabili</li>
        <li>Assistenza clienti e gestione di reclami</li>
        <li>Invio di comunicazioni commerciali e newsletter (solo previo consenso esplicito)</li>
        <li>Analisi statistica anonima per migliorare il sito</li>
        <li>Generazione di risposte personalizzate tramite assistente AI (chat di OBI)</li>
      </ul>
    </Section>

    <Section title="4. Base giuridica">
      <p>
        Il trattamento si basa su: (a) esecuzione del contratto, (b) obblighi di legge,
        (c) consenso esplicito dell'interessato per finalità di marketing, (d) legittimo
        interesse del Titolare per finalità di analisi statistica e sicurezza del sito.
      </p>
    </Section>

    <Section title="5. Conservazione dei dati">
      <p>
        I dati relativi agli ordini sono conservati per 10 anni come previsto dalla
        normativa fiscale italiana. I dati di navigazione e di marketing sono conservati
        per 24 mesi, salvo revoca del consenso. Le conversazioni con l'assistente AI sono
        conservate per 6 mesi a scopo di miglioramento del servizio.
      </p>
    </Section>

    <Section title="6. Comunicazione e destinatari dei dati">
      <p>
        I dati possono essere comunicati a:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Corrieri e spedizionieri per la consegna degli ordini</li>
        <li>Provider di pagamento (PayPal, gateway WooCommerce)</li>
        <li>Provider di hosting (Aruba, Emergent) e database (MongoDB Atlas)</li>
        <li>Provider di servizi AI (Anthropic, Emergent Universal Key) per la generazione di risposte personalizzate</li>
        <li>Consulenti contabili e fiscali</li>
        <li>Autorità giudiziarie e amministrative su richiesta</li>
      </ul>
    </Section>

    <Section title="7. Trasferimento extra-UE">
      <p>
        Alcuni fornitori (es. Anthropic per i servizi AI) potrebbero trattare dati al di
        fuori dell'Unione Europea. In tali casi il trasferimento avviene sulla base delle
        Clausole Contrattuali Standard approvate dalla Commissione Europea.
      </p>
    </Section>

    <Section title="8. Diritti dell'interessato">
      <p>
        L'utente ha diritto, in qualsiasi momento, di:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Accedere ai propri dati personali</li>
        <li>Richiederne rettifica, aggiornamento o cancellazione</li>
        <li>Limitare od opporsi al trattamento</li>
        <li>Richiedere la portabilità dei dati</li>
        <li>Revocare il consenso prestato</li>
        <li>Proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">garanteprivacy.it</a>)</li>
      </ul>
      <p>
        Per esercitare i propri diritti è sufficiente scrivere a{" "}
        <a href={`mailto:${COMPANY.email}`} className="text-sky-600 underline">{COMPANY.email}</a>.
      </p>
    </Section>

    <Section title="9. Cookie">
      <p>
        Per informazioni dettagliate sui cookie utilizzati consulta la{" "}
        <a href="/cookie-policy" className="text-sky-600 underline">Cookie Policy</a>.
      </p>
    </Section>

    <p className="text-sm text-slate-500 pt-6 border-t">
      Documento di esempio non legalmente vincolante. Si consiglia di farlo rivedere dal
      proprio DPO o consulente legale prima della pubblicazione definitiva.
    </p>
  </LegalLayout>
);

export default PrivacyPage;
